import React from 'react';
import { useStyletron } from 'baseui';

const UpTriangularArrow = ({ fill, width, height }: { fill?: string; width?: number; height?: number }) => {
	const [css, theme] = useStyletron();

	return (
		<svg
			width={width || 8}
			height={height || 5}
			viewBox={`0 0 ${width || 8} ${height || 5}`}
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
		>
			<path
				d='M4.23168 0.533761C3.92193 0.235709 3.43202 0.235709 3.12228 0.533761L0.430902 3.12354C-0.0880327 3.62288 0.265435 4.5 0.985602 4.5H6.36836C7.08852 4.5 7.44199 3.62289 6.92306 3.12354L4.23168 0.533761Z'
				fill={fill || theme.colors.primaryA}
			/>
		</svg>
	);
};

export default UpTriangularArrow;
